import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { rolesToCheck } from 'src/app/constants/global.constant';
import { environment } from 'src/environments/environment';
import {AuthentificationService} from "./authentification.service";
import { ConfigurationService } from '../configuration.service';


@Injectable({
  providedIn: 'root'
})
export class SourceAuthoritesAfterAuthenticationService {

  constructor(private AuthServ: AuthentificationService, private cookieService: CookieService, private configurationService: ConfigurationService) {
    this.setConfiguration()
  }


  public get accessDenied() {
      if ( this.AuthServ.getStoredAccess()){
          const listSourceRoles: string[] = JSON.parse(this.cookieService.get('access'))?.sourceRoles || [];
          const anyRoleExists = rolesToCheck.some(role => listSourceRoles.includes(role));
          return anyRoleExists && listSourceRoles?.length === 1;
      }
      return false;
  }
  private setConfiguration() {

    if (this.configurationService.get() != null){
      this.configurationService.get().isFormActionDisabled = this.accessDenied
      
  }
}
}
